import {
  MERCHANT_COUNTRIES_LOAD_SUCCESS,
  MERCHANT_RESORTS_LOAD_SUCCESS,
  MERCHANT_LIST_LOAD_SUCCESS,
  MERCHANT_LIST_SELECT,
  MERCHANT_LIST_SUCCESS,
  MERCHANT_LIST_SORT,
  MERCHANT_LIST_FILTER,
  MERCHANT_LIST_CHANGE_PAGE,
  MERCHANT_LIST_TOGGLE_FILTERING,
  MERCHANT_INFO_SUCCESS,
  MERCHANT_INFO_UPDATE_SUCCESS,
  MERCHANT_USERS_LOAD_SUCCESS,
  MERCHANT_USERS_DELETE_SUCCESS,
  MERCHANT_USERS_EDIT_MODE,
  MERCHANT_USERS_INPUTS_CHANGE,
  MERCHANT_PARAMETERS_FETCH_SUCCESS,
  MERCHANT_PARAMETERS_DELETE_SUCCESS,
  MERCHANT_PARAMETERS_SAVE_SUCCESS,
  MERCHANT_PARAMETERS_EDIT_MODE,
  MERCHANT_PARAMETERS_INPUTS_CHANGE,
  MERCHANT_E_TICKET_FETCH_SUCCESS,
  MERCHANT_E_TICKET_SAVE_SUCCESS,
  MERCHANT_BILLING_SAVE_SUCCESS,
  TOS_LOAD_SUCCESS,
  TOS_UPLOAD_PROGRESS,
  TOS_UPLOAD_DONE,
  CSV_ERRORS,
  IMPORT_APIDAE_DATA_SUCCESS,
  CITIES_LOAD_SUCCESS
} from "../actions";

import { projectById } from "../services/project";

const MERCHANT_SHAPE = {
  countries: [],
  list: {
    byId: {},
    all: [],
    filtering: true,
    selected: null,
    sortColumn: null,
    sortDescending: false,
    q: "",
    kind: undefined,
    total: 0,
    page: 0,
    pageCount: 0,
    exportUrl: null
  },
  detail: {},
  tos: {},
  resorts: [],
  merchantList: [],
  hebergement: {}
};

const sortDescending = (state, column) =>
  state.list.sortColumn === column ? !state.list.sortDescending : false;

const toggleSelected = (state, selected) =>
  state.list.selected !== selected ? selected : undefined;

const toggleFiltering = state => !state.list.filtering;

export default (state = MERCHANT_SHAPE, action) => {
  switch (action.type) {
    case MERCHANT_RESORTS_LOAD_SUCCESS:
      return {
        ...state,
        resorts: action.resorts
      };
    case MERCHANT_COUNTRIES_LOAD_SUCCESS: {
      console.log("Success", action);
      return {
        ...state,
        countries: action.countries
      };
    }

    case MERCHANT_LIST_LOAD_SUCCESS:
      return {
        ...state,
        merchantList: action.merchants
      };

    case MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          ...projectById(action.data.items),
          total: action.data.total,
          page: action.data.page,
          pageCount: action.data.pageCount,
          exportUrl: action.data.exportUrl
        }
      };

    case MERCHANT_LIST_SORT:
      return {
        ...state,
        list: {
          ...state.list,
          sortColumn: action.column,
          sortDescending: sortDescending(state, action.column)
        }
      };

    case MERCHANT_LIST_CHANGE_PAGE:
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };

    case MERCHANT_LIST_FILTER:
      return {
        ...state,
        list: {
          ...state.list,
          page: 1,
          q: action.q,
          kind: action.kind
        }
      };

    case MERCHANT_LIST_SELECT:
      return {
        ...state,
        list: {
          ...state.list,
          selected: toggleSelected(state, action.selected)
        }
      };

    case MERCHANT_LIST_TOGGLE_FILTERING:
      return {
        ...state,
        list: {
          ...state.list,
          filtering: toggleFiltering(state)
        }
      };

    case MERCHANT_PARAMETERS_EDIT_MODE:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          configs: state.parameters.configs.map(x => ({
            ...x,
            editing: x.id === action.id
          }))
        }
      };
    case MERCHANT_PARAMETERS_FETCH_SUCCESS:
    case MERCHANT_PARAMETERS_SAVE_SUCCESS:
      return {
        ...state,
        parameters: {
          ...action.parameters,
          configs: action.parameters.configs.map(x => ({
            ...x,
            editing: false
          })),
          newConfig: { value: "", code: "" }
        }
      };
    case MERCHANT_PARAMETERS_DELETE_SUCCESS: {
      return {
        ...state,
        parameters: {
          ...state.parameters,
          configs: state.parameters.configs.filter(x => x.id !== action.id)
        }
      };
    }

    case MERCHANT_PARAMETERS_INPUTS_CHANGE:
      return action.id
        ? {
            ...state,
            parameters: {
              ...state.parameters,
              configs: state.parameters.configs.map(x =>
                x.id === action.id ? { ...x, [action.field]: action.value } : x
              )
            }
          }
        : {
            ...state,
            parameters: {
              ...state.parameters,
              newConfig: {
                ...state.parameters.newConfig,
                [action.field]: action.value
              }
            }
          };

    case MERCHANT_E_TICKET_FETCH_SUCCESS:
    case MERCHANT_E_TICKET_SAVE_SUCCESS:
      return {
        ...state,
        eTicket: action.status
      };

    case MERCHANT_INFO_SUCCESS:
      return {
        ...state,
        detail: { ...action.merchant, newUser: { login: "", email: "" } }
      };

    case MERCHANT_INFO_UPDATE_SUCCESS:
      return {
        ...state,
        detail: action.merchant
      };

    case MERCHANT_USERS_LOAD_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          users: [
            ...action.users,
            { id: "new", login: "", email: "", editing: true, newUser: true }
          ]
        }
      };

    case MERCHANT_USERS_DELETE_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          users: [
            ...action.users,
            { id: "new", login: "", email: "", editing: true, newUser: true }
          ]
        }
      };

    case MERCHANT_USERS_EDIT_MODE:
      return {
        ...state,
        detail: {
          ...state.detail,
          users: state.detail.users.map(user => ({
            ...user,
            editing: user.id === action.id
          }))
        }
      };

    case MERCHANT_USERS_INPUTS_CHANGE: {
      if (action.id) {
        return {
          ...state,
          detail: {
            ...state.detail,
            users: state.detail.users.map(user =>
              user.id === action.id ? { ...user, email: action.email } : user
            )
          }
        };
      } else {
        return {
          ...state,
          detail: {
            ...state.detail,
            newUser: {
              ...state.detail.newUser,
              login: action.login,
              email: action.email
            }
          }
        };
      }
    }

    case MERCHANT_BILLING_SAVE_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          billing: {
            name: action.name,
            address: action.address,
            address2: action.address2,
            postalCode: action.postalCode,
            city: action.city,
            country: action.country,
            siret: action.siret,
            identifier: action.identifier,
            codeApe: action.codeApe,
            phone: action.phone,
            fax: action.fax,
            email: action.email,
            contact: action.contact
          }
        }
      };
    }

    case TOS_LOAD_SUCCESS: {
      return {
        ...state,
        tos: action.tos
      };
    }

    case TOS_UPLOAD_DONE: {
      return {
        ...state,
        tos: action.data
      };
    }

    case TOS_UPLOAD_PROGRESS: {
      return {
        ...state,
        tos: {
          ...state.tos,
          [action.kind]: {
            ...state.tos[action.kind],
            percentage: action.percentage + "%"
          }
        }
      };
    }

    case CSV_ERRORS: {
      return {
        ...state,
        csvErrors: action.errors
      };
    }

    case CITIES_LOAD_SUCCESS: {
      return {
        ...state,
        authorizedCities: action.cities,
        resorts: action.resorts
      };
    }

    case IMPORT_APIDAE_DATA_SUCCESS: {
      return {
        ...state,
        hebergement: action.result
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/merchant/reducers.js